"use strict";

module.exports = sortBy;
function sortBy(comparator, array) {
  return array.slice().sort(comparator);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/nanoutils/cjs/sortBy/sortBy.js
// module id = 531
// module chunks = 0